import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation, Link  } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Login = () => {
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { user, login, loading } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  // Получаем путь, с котрого пользователь пришел, или на главную страницу
  const from = location.state?.from?.pathname || '/';
  const registerMessage = location.state?.message;

  // Перенаправляем если пользователь уже авторизирован
  useEffect(() => {
    if (user && !loading) {
      navigate(from, { replace: true });
    }
  }, [user, loading, navigate, from]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);
    
    const result = await login(credentials);

    if (result.success) {
      // Перенаправляем на страницу, с которой пришел пользователь, или на главную
      navigate(from, { replace: true });
    } else {
      setError(result.error);
    }

    setIsLoading(false);
  };

  const handleChange = (e) => {
    setCredentials({
      ...credentials,
      [e.target.name]: e.target.value
    });
  };

  // Показываем лоадер во время проверки авторизации
  if (loading) {
    return <div className="loading">Авторизация...</div>;
  }

  // Если пользователь авторизирован, не показываем форму логина
  if (user) {
    return <div className="loading">Перенаправление...</div>;
  }

  return (
    <div className="login-container">
      <h2>Авторизация</h2>
      {registerMessage && <div className="success">{registerMessage}</div>}
      <form onSubmit={handleSubmit}>
        <div>
          <label>Логин:</label>
          <input
            type="text"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            required
            disabled={isLoading}
            autoComplete="username"
          />
        </div>
        <div>
          <label>Пароль:</label>
          <input
            type="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            required
            disabled={isLoading}
            autoComplete="current-password"
          />
        </div>
        {error && <div className="error">Не удалось войти</div>}
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Авторизация...' : 'Войти'}
        </button>
      </form>
    </div>
  );
};

export default Login;